import { render, staticRenderFns } from "./addAdvertise.vue?vue&type=template&id=6548a21d&scoped=true"
import script from "./addAdvertise.vue?vue&type=script&lang=js"
export * from "./addAdvertise.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addAdvertise.vue?vue&type=style&index=1&id=6548a21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548a21d",
  null
  
)

export default component.exports